export default __webpack_public_path__ + "static/media/logo_light.dedbc991.png";